import React, {useEffect} from "react";
import { Route, Routes } from "react-router-dom";
import MaterialType from "../layout/materialType/MaterialType";
import AddMaterialType from "../layout/materialType/AddMaterialType";
function MaterialTypePage() {
    useEffect(() => {
        return() =>{
            localStorage.removeItem("selectedId")
            localStorage.removeItem("itemOffset")
            localStorage.removeItem("forcePage")
        }
    }, []);
  return (
    <>
      <Routes>
        <Route path="/" element={<MaterialType />} />
        <Route path="/add" element={<AddMaterialType />} />
        <Route path="/update/:id" element={<AddMaterialType />} />
      </Routes>
    </>
  );
}

export default MaterialTypePage;
